import { FC } from 'react';
import { Avatar, Heading } from '@livechat/design-system-react-components';

import * as styles from './styles';

type Props = {
  avatarUrl?: string;
  userName: string;
  textContent: string;
};

export const AvatarHero: FC<Props> = ({ avatarUrl, userName, textContent }) => (
  <div css={styles.container}>
    {avatarUrl ? (
      <Avatar src={avatarUrl} type="image" css={styles.avatarSize} />
    ) : (
      <Avatar text={userName} type="text" size="xxlarge" css={styles.avatarSize} />
    )}
    <div css={styles.content}>
      <Heading css={styles.largeHeading}>Hello {userName}!</Heading>
      <Heading size="xs" css={styles.smallHeading}>
        {textContent.replace('. ', '.\n')}
      </Heading>
    </div>
  </div>
);
